import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, catchError, map } from 'rxjs';
import { TenantService, TenantContext } from '../services/tenant.service';
import { ApiConfigService } from '../api/api-config.service';

interface TenantByHostnameDTO {
  id: number;
  name: string;
  key: string;
  slug: string;
  hostname: string;
}

const COMPLEET_HOSTNAMES = [
  'app.compleet.com.br',
  'aplicacao.compleet.com.br',
  'homologacao.compleet.com.br',
  'localhost',
  '127.0.0.1',
];

@Injectable({ providedIn: 'root' })
export class TenantBootstrapService {
  private readonly http = inject(HttpClient);
  private readonly api = inject(ApiConfigService);
  private readonly tenantService = inject(TenantService);

  resolve(hostname: string = window.location.hostname): Observable<void> {
    if (COMPLEET_HOSTNAMES.includes(hostname)) {
      this.tenantService.setMode('multitenant');
      return of(undefined);
    }

    this.tenantService.setMode('whitelabel');

    const params = new HttpParams().set('host', hostname);

    return this.http
      .get<TenantByHostnameDTO>(this.api.url('/api/auth/tenant-by-hostname'), { params })
      .pipe(
        map(dto => {
          const tenant: TenantContext = {
            id: dto.key,
            organizationId: dto.id,
            name: dto.name,
          };
          this.tenantService.setActiveTenant(tenant);
        }),
        catchError(() => {
          // Host whitelabel sem tenant cadastrado (404) ou erro de rede: nunca deixar o login
          // sem tenant — um domínio novo/não mapeado cai para multitenant em vez de bloquear
          // o acesso de todo mundo (incidente 2026-10-12: aplicacao.compleet.com.br).
          this.tenantService.setMode('multitenant');
          return of(undefined);
        })
      );
  }
}
